// Centralized Flickity module
// This module handles all Flickity carousel initialization and management

let flickityInstance = null;
let flickityReady = false;

// Default Flickity settings
const defaultSettings = {
  cellAlign: "center",
  autoPlay: 8000,
  groupCells: true,
  draggable: true,
  pageDots: true,
  prevNextButtons: false,
  wrapAround: true,
  imagesLoaded: true,
  lazyLoad: true,
};

// Initialize Flickity library
const initFlickity = async () => {
  if (flickityReady) return window.Flickity;

  try {
    const Flickity = await import("flickity");
    window.Flickity = Flickity.default;
    flickityReady = true;

    // Dispatch ready event
    window.dispatchEvent(new CustomEvent("flickityReady"));

    return window.Flickity;
  } catch (error) {
    console.error("Failed to load Flickity:", error);
    return null;
  }
};

// Create a new Flickity instance with custom settings
const createFlickity = (element, customSettings = {}) => {
  if (!flickityReady || !window.Flickity) {
    console.warn("Flickity not ready yet, will retry...");
    // Return a promise that resolves when Flickity is ready
    return new Promise((resolve) => {
      whenFlickityReady(() => {
        const settings = { ...defaultSettings, ...customSettings };
        resolve(new window.Flickity(element, settings));
      });
    });
  }

  const settings = { ...defaultSettings, ...customSettings };
  return new window.Flickity(element, settings);
};

// Wait for Flickity to be ready and then execute callback
const whenFlickityReady = (callback) => {
  if (flickityReady) {
    callback();
  } else {
    window.addEventListener("flickityReady", callback, { once: true });
  }
};

// Setup arrow navigation for a Flickity instance
const setupArrowNavigation = (flickityInstance, containerSelector) => {
  if (!flickityInstance) return;

  $(containerSelector)
    .on("click", ".arrows.prev", (event) => {
      event.preventDefault();
      flickityInstance.previous();
      return true;
    })
    .on("click", ".arrows.next", (event) => {
      event.preventDefault();
      flickityInstance.next();
      return true;
    });
};

// Setup click handlers for Flickity cells
const setupClickHandlers = (flickityInstance, clickCallback) => {
  if (!flickityInstance || !clickCallback) return;

  flickityInstance.on(
    "staticClick.flickity",
    (event, pointer, cellElement, cellIndex) => {
      if (!cellElement) return;
      clickCallback(cellElement, cellIndex);
    }
  );
};

// Export functions for use in other modules
export {
  initFlickity,
  createFlickity,
  whenFlickityReady,
  setupArrowNavigation,
  setupClickHandlers,
  defaultSettings,
};
